import rehypeToRemark from 'rehype-remark';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import remarkParse from 'remark-parse';
import remark2rehype from 'remark-rehype';
import remarkStringify from 'remark-stringify';
import { unified } from 'unified';

// Modify the default schema to only include tags we support
// Spread the defaultSchema to avoid changing it for other imports
const simpleSchema = { ...defaultSchema };
simpleSchema.tagNames = [
  'br',
  'strong',
  'em',
  'div',
  'p',
  'ol',
  'ul',
  'li',
  'span',
];

// Converts our legacy markdown like summary strings to markdown
// This assures that unsupported markdown syntax from the summary string is escaped
export default function summaryToMarkdown(summary: string): string {
  const file = unified()
    .use(remarkParse)
    .use(remark2rehype)
    .use(rehypeSanitize, simpleSchema)
    .use(rehypeToRemark)
    .use(remarkStringify, { bullet: '-', listItemIndent: 'one' })
    .processSync(summary);

  return String(file);
}
